import React from "react";
import { useTranslation } from "react-i18next";
import { Goal } from "../../../types/goals";
import DateYearCounter from "../Input/DateYearCounter";
import Dropdown from "../Input/Dropdown";
import TargetTextfield from "../Input/TargetTextfield";

interface AddGoalFormProps {
  values: Goal;
  onChange: (field: keyof Goal, value: string | number) => void;
}

const goalOptions = [
  { label: "Saving for college or university", value: "CollegeFund" },
  { label: "Saving for trade school", value: "TradeSchoolFund" },
];

const AddGoalForm: React.FC<AddGoalFormProps> = ({ values, onChange }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex  justify-between items-center h-full">
        <h3 className="text-lg text-[20px]">{values.fullName}</h3>
      </div>

      <div className="space-y-4 my-[24px]">
        <Dropdown
          name="purpose"
          label="Purpose"
          showToolTip
          toolTipText={t("onboarding.goals.purpose_tooltip")}
          value={values.purpose}
          options={goalOptions}
          onChange={(e) => onChange("purpose", e.target.value)}
        />

        <div className="flex flex-col md:flex-row space-x-0 md:space-x-[12px] space-y-4 md:space-y-0">
          <div className="w-full md:w-2/5">
            <DateYearCounter
              initialValue={values?.year}
              onChange={(value) => onChange("year", parseInt(value))}
              disabled={values.purpose === ""}
            />
          </div>
          <div className="w-full md:w-3/5">
            <TargetTextfield
              name="amount"
              //value={values.amount}
              value={values.amount === 0 ? "" : values.amount}
              onValueChange={(val) => onChange("amount", val)}
              disabled={values.purpose === ""}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddGoalForm;
